import React from 'react'
import { IProps } from './index'
import { useSessionStorage } from '../../hooks/use-session-storage'
import { CTALink } from '../CTALink'
import { localiseURL } from '../../utils/localiseURL'
import useLocaleCode from '../../hooks/useLocaleCode'

export const InboundCTA: React.FC<IProps> = ({ cta }) => {
  const [isUma] = useSessionStorage('is-uma', false)
  const localeCode = useLocaleCode()

  const getInboundURl = (isUMA: boolean) => {
    if (isUMA) return localiseURL('/pricing', localeCode)
    return localiseURL('/pricing', localeCode)
  }

  return <CTALink {...cta} url={getInboundURl(isUma)} />
}
